/* global Word */
/**
 * Estilo da marca (que NÃO é de lista) em parágrafos que JÁ existem, sem perder
 * a ênfase do conteúdo: trocar o estilo apaga negrito, itálico e sobrescrito do
 * texto (medido — ver inlineEmphasis.ts). Usado pelas ferramentas de estilo e
 * pela formatação de documento existente.
 *
 * Título não recebe a ênfase de volta: a tipografia dele é do estilo. Citação
 * não recebe o itálico (o estilo já é itálico).
 */
import { applyHouseParagraphStyle } from './houseStyle';
import { captureEmphasis, restoreEmphasis } from './inlineEmphasis';
const isHeadingRef = (ref) => /^heading_/.test(ref);
/** Aplica os estilos (um sync) e devolve quantos trechos de ênfase não deu para isolar. */
export async function restyleExisting(context, paras, refs) {
    if (!paras.length)
        return 0;
    const retratos = await captureEmphasis(context, paras);
    paras.forEach((p, i) => applyHouseParagraphStyle(p, refs[i]));
    paras.forEach((_, i) => {
        if (!isHeadingRef(refs[i])) {
            restoreEmphasis(retratos[i], { skipItalic: refs[i].startsWith('quote_') });
        }
    });
    await context.sync();
    return retratos.reduce((n, r, i) => n + (isHeadingRef(refs[i]) ? 0 : r.unresolved), 0);
}
